import React, { Component } from "react";
import { connect } from "react-redux";
import { DotLoaderOverlay } from "react-spinner-overlay";
import { ReactComponent as Clock } from "../../assets/icons/clock.svg";
import { ReactComponent as Search } from "../../assets/icons/search.svg";

import Button from "../../components/Button";
import TextInput from "../../components/TextInput";
import { getListRiwayat } from "../../redux/actions";
import { formatTime, formatDate } from "../../helpers/functionFormat";

class Riwayat extends Component {
  _mounted = true;
  searchDebounceTimer = null;

  state = {
    location: "",
    date: "",
    time: "",
    listData: [],
    loading: true,
    tableState: {
      search: "",
    },
  };

  componentWillUnmount() {
    this._mounted = false;
    clearInterval(this.intervalTime);
    if (this.searchDebounceTimer) {
      clearTimeout(this.searchDebounceTimer);
    }
  }

  componentDidMount() {
    this._isMounted = true;
    this.updateTime();
    this.loadData();
    this.intervalTime = setInterval(() => this.updateTime(), 1000);
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevState.tableState.search !== this.state.tableState.search) {
      // Clear previous timer
      if (this.searchDebounceTimer) {
        clearTimeout(this.searchDebounceTimer);
      }
      // Set new timer with 500ms delay
      this.searchDebounceTimer = setTimeout(() => {
        this.loadData();
      }, 500);
    }
  }

  updateTime() {
    let date = new Date();
    if (this._mounted) {
      this.setState({
        date: formatDate(date, 3),
        time: formatTime(date, true),
      });
    }
  }

  loadData = async () => {
    this.setState({ loading: true });
    try {
      const data = await this.props.onGetListRiwayat(this.state.tableState);
      if (this._mounted) {
        this.setState({ listData: data.data.data, loading: false });
      }
      if (data?.data?.status_code === 401) {
        this.props.history.push("/login");
        window.location.reload();
      }
    } catch (error) {
      if (this._mounted) {
        this.setState({ loading: false });
      }
    }
  };

  render() {
    return (
      <div className="pb-4">
        <DotLoaderOverlay
          loading={this.state.loading}
          overlayColor="rgba(0,0,0,0.1)"
          color={"#CF1701"}
        />
        <div className="flex px-1 md:px-24 my-8">
          <div className="md:flex md:justify-between bg-white w-2/3 md:w-4/5 py-4 p-2 rounded-lg items-center md:px-4 card">
            <span className="text-third font-semibold text-md md:text-sm">
              Jakarta | {this.state.date}
            </span>
            <div className="flex items-center md:mt-0 mt-1">
              <Clock className="mr-1 w-4 md:mr-2 md:w-6" />
              <span className="text-third text-sm">{this.state.time}</span>
            </div>
          </div>
          <Button
            bgColor="bg-third"
            className="w-1/3 md:w-1/5 ml-4  px-0 md:px-6"
            title="Kembali ke Beranda"
            onClick={() => this.props.history.push("/")}
          />
        </div>
        <div className="mx-1 md:mx-24 bg-white rounded-lg py-1 card min-h-5/6">
          <div className="flex items-center justify-between py-2 px-4 border-b">
            <h3 className="text-lg font-bold">Riwayat Lelang</h3>
            <div className="md:w-1/4 w-2/3">
              <TextInput
                className="flex flex-1 border-0 px-1 m-1 font-sourceSansPro focus:outline-none focus:border-none"
                lefticon={<Search />}
                placeholder="Cari Lelang"
                value={this.state.tableState.search}
                onChange={(e) =>
                  this.setState((prevState) => {
                    return {
                      ...prevState,
                      tableState: {
                        ...prevState.tableState,
                        search: e.target.value,
                      },
                    };
                  })
                }
              />
            </div>
          </div>
          {this.state.listData.length === 0 && !this.state.loading ? (
            <div className="flex flex-col items-center justify-center py-16 px-4">
              <div className="text-center">
                <svg
                  className="mx-auto h-16 w-16 text-gray-400 mb-4"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={1.5}
                    d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"
                  />
                </svg>
                <h3 className="text-lg font-semibold text-gray-700 mb-2">
                  Tidak Ada Riwayat Lelang
                </h3>
                <p className="text-sm text-gray-500">
                  {this.state.tableState.search
                    ? `Tidak ditemukan riwayat lelang dengan kata kunci "${this.state.tableState.search}"`
                    : "Belum ada riwayat lelang yang tersedia"}
                </p>
              </div>
            </div>
          ) : (
            this.state.listData.map((item, index) => (
              <div
                key={index.toString()}
                className={`flex items-center px-4 py-2 justify-between ${
                  index % 2 === 1 ? "bg-white" : "bg-[#F9FAFB]"
                } ${
                  index === this.state.listData.length - 1 ? "border-b" : ""
                }`}
              >
                <div className="md:w-5/12 w-1/2">
                  <label className="block text-third text-md font-semibold mb-1">
                    Lelang {item.location.city.name} #{item.auction_number}
                  </label>
                  <label className="hidden md:block text-sm text-secondary">
                    {`${item.location.city.name} ● ${formatDate(
                      item.date_start,
                      3
                    )}, ${item.time_start}`}
                  </label>
                  <label className="block md:hidden text-sm text-secondary">
                    {item.date_start}
                  </label>
                  <label className="block md:hidden text-sm text-secondary">
                    {item.time_start}
                  </label>
                </div>
                <div className="md:w-5/12 w-1/2 mx-1">
                  <label className="block text-third text-md font-semibold mb-1">
                    {item.name}
                  </label>
                  <label className="block text-sm text-secondary">
                    {item.role}
                  </label>
                </div>
                <div className="block">
                  <Button
                    bgColor="bg-white"
                    color="text-third"
                    className="text-sm font-semibold border border-secondary hover:bg-gray-200"
                    title="Lihat Detail"
                    onClick={() =>
                      this.props.history.push(`/detail-riwayat/${item.id}`)
                    }
                  />
                </div>
              </div>
            ))
          )}
        </div>
      </div>
    );
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    onGetListRiwayat: (params) => dispatch(getListRiwayat(params)),
  };
};

export default connect(null, mapDispatchToProps)(Riwayat);
